import { z } from 'zod';
import { BaseValidations } from '@anytag/shared-validations';

export const EngagementBulkEditSchema = z.object({
  netBudget: BaseValidations.IntegerSchema.or(z.literal('')),
  influencerCost: BaseValidations.IntegerSchema.or(z.literal(''))
});
